<template>
  <div class="valid">
    <div :class="'status '+isvalid"></div>
    <div class="vLabel">{{label}}</div> 
  </div>
</template>

<script>
export default {
  name: 'textInput',
  props: ["valid","label"],
  data() {
      return {
        
      }
  },
  mounted(){
   
  },
  computed:{
    isvalid(){
      if(this.valid){
        return "isvalid"
      }else{
        return "invalid"
      }
    }
  }
    
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";
  .valid{
    display:flex;
  }
  .status{
    margin-top:5px;
    margin-left:10px;
    width:15px;
    height:15px;
    border-radius:100%;
    background-color: #777;
  }
  .vLabel{
    margin-top:0px;
    margin-left:5px;
    font-size:inherit;
    color:#f00;
  }
  .status.invalid{
    background-color: red;
  }
  .status.isvalid{
    background-color: green;
  }
</style>
